import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export default function PortfolioReturnsHelp() {
    return (
        <IconTooltip>
            <div>
                This chart displays the price movement of your basket over time
                versus the order&apos;s previous day&apos;s close. This can be
                changed to a specific day or time in the chart&apos;s
                configuration&nbsp;
                <Icon name="cog" />.
            </div>
            <div>
                Index comparisons can be added in the chart&apos;s configuration
                and used to view price changes in the market compared to your
                basket.
            </div>
            <div>
                The basket is split into Buy, Sell, Short and net total
                (calculated as Sells – Buys). In the global settings, Buys can
                be shown as positive, and Shorts and Sells can either be merged
                or split.
            </div>
        </IconTooltip>
    );
}
